import component from "frontend/legacy/unavailable-noop"

export default component
